// assets
import { IconBrandChrome, IconHelp, IconUser } from '@tabler/icons';
import CribOutlinedIcon from '@mui/icons-material/CribOutlined';
import LocalMallIcon from '@mui/icons-material/LocalMall';
// constant
const icons = { IconBrandChrome, IconHelp, IconUser };

// ==============================|| USER PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const order = {
    id: 'user-docs-roadmap4',
    type: 'group',
    children: [
        {
            id: 'order',
            title: 'Current Orders',
            type: 'item',
            url: '/order',
            icon: LocalMallIcon,
            breadcrumbs: false
        }
    ]
};

export default order;
